module.exports = {"version":"1762863971965"}


//////////////////
// WEBPACK FOOTER
// ./static/version.json
// module id = c+VB
// module chunks = 78